export const partners_en = {
    title: "Partners",
    description: 'Building partnerships between enterprises is one of the tasks of CleVR. For this, we establish strong ties with both individual enterprises and production associations, technoparks, exhibition operators and other organizations. We are always ready to expand our partner network and start a constructive dialogue!',
}